import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { setFilePath, setIsOpenDialog } from '../../../application/features/global-search/globalSearchSlice';
import { useAppDispatch, useAppSelector } from '../../../application/store/useStore';
import useTranslate from '../../../localization/helpers';
var FileViewer = function () {
    var translate = useTranslate().translate;
    var dispatch = useAppDispatch();
    var _a = useAppSelector(function (state) { return state.globalSearch; }), isOpenDialog = _a.isOpenDialog, filePath = _a.filePath;
    var handleClose = function () {
        dispatch(setFilePath(''));
        dispatch(setIsOpenDialog(false));
    };
    return (_jsxs(Dialog, { open: isOpenDialog, onClose: handleClose, maxWidth: 'lg', fullWidth: true, slotProps: {
            paper: {
                style: {
                    height: '90vh'
                }
            }
        }, children: [_jsxs(DialogTitle, { sx: { m: 0, p: 2 }, children: [translate('common.documentPreview'), _jsx(IconButton, { "aria-label": 'close', onClick: handleClose, sx: {
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: function (theme) { return theme.palette.grey[500]; }
                        }, children: _jsx(CloseIcon, {}) })] }), _jsx(DialogContent, { style: { height: '100%' }, children: filePath && (_jsx("embed", { src: filePath, title: 'Test', width: '100%', height: '100%', style: { border: 'none' } }, filePath)) })] }));
};
export default FileViewer;
